module.exports = __webpack_public_path__ + "img/190.34ed44bb.jpg";